var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDicomLabLogoDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Smart_guide",
    "data-name": "Smart guide",
    xmlns: "http://www.w3.org/2000/svg",
    width: 227.341,
    height: 70.001,
    viewBox: "0 0 227.341 70.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7659",
    "data-name": "Path 7659",
    d: "M0,64.48V38.2L5.476,32.72H11.5L15.88,37.1V18.3H23V69.956H17.8l-.456-5.111-5.111,5.111H5.476Zm11.864.183,3.924-4.016V42.668L11.317,38.1H9.035L7.027,40.2V62.655l2.008,2.008Z",
    transform: "translate(0 -1.689)",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7660",
    "data-name": "Path 7660",
    d: "M32,19h7.027v8.579H32Zm0,13.781h7.027V70.108H32Z",
    transform: "translate(-2.795 -1.75)",
    fill: "#585858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7661",
    "data-name": "Path 7661",
    d: "M46,65.851V39.567L51.476,34H62.245l5.476,5.567v7.027H60.694V41.21L58.686,39.2H55.035L53.027,41.21V64.117l2.008,2.1h3.651l2.008-2.1V58.733h7.027v7.119l-5.476,5.476H51.476Z",
    transform: "translate(-4.018 -3.061)",
    fill: "#585858"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7662",
    "data-name": "Path 7662",
    d: "M74.2,65.86V39.576L79.676,34.1H91.358l5.476,5.476V65.951l-5.476,5.476H79.585Zm13.507.365,2.008-2.008v-23l-2.008-2.008H83.235l-2.008,2.008V64.126l2.008,2.008h4.472Z",
    transform: "translate(-6.482 -3.07)",
    fill: "#585858"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7663",
    "data-name": "Path 7663",
    d: "M104.2,34.1h5.2l.274,5.385,5.476-5.385h5.02l4.563,4.563L129.3,34.1h5.75l5.476,5.476v31.76H133.4V41.949L131.4,39.941h-1.46l-4.107,4.016V71.336H118.8V41.949l-2.008-2.008h-1.1l-4.472,4.472V71.336H104.2Z",
    transform: "translate(-9.102 -3.07)",
    fill: "#585858"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7664",
    "data-name": "Path 7664",
    d: "M150.3,18.3h7.392V63.567H169.1v6.389H150.3Z",
    transform: "translate(-13.129 -1.689)",
    fill: "#585858"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7665",
    "data-name": "Path 7665",
    d: "M210.1,18.3h18.892l5.841,5.932V38.378L229.9,43.307l4.928,5.02v15.7l-5.841,5.932H210.1Zm14.146,21.995,3.1-3.1V26.879l-2.464-2.464h-7.392V40.386h6.754Zm.639,23.638,2.464-2.464V49.6l-3.1-3.1h-6.754V64.024h7.392Z",
    transform: "translate(-18.354 -1.689)",
    fill: "#585858"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7666",
    "data-name": "Path 7666",
    d: "M186.981,48.62a5.586,5.586,0,1,0-6.023-5.111,5.6,5.6,0,0,0,6.023,5.111m4.472-33.22L204.5,68.7l-9.948.913-11.864,1-9.492.821,3.559-54.759Z",
    transform: "translate(-15.129 -1.436)",
    fill: "#6caddf"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(212.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7667",
    "data-name": "Path 7667",
    d: "M240.4,14.7a7.3,7.3,0,1,1,7.3-7.3A7.323,7.323,0,0,1,240.4,14.7Zm0-13.507a6.115,6.115,0,1,0,6.115,6.115A6.115,6.115,0,0,0,240.4,1.2Z",
    transform: "translate(-233.1 -0.1)",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(4.746 3.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7668",
    "data-name": "Path 7668",
    d: "M243.958,6.582a2.033,2.033,0,0,1-1.551,2.19l1.825,2.555h-1.551l-1.643-2.373h-1.551v2.373H238.3V4.3h2.647a3.634,3.634,0,0,1,2.282.548A1.848,1.848,0,0,1,243.958,6.582Zm-1.551,1a1.137,1.137,0,0,0,.365-1c0-.456-.091-.821-.365-.913a2.565,2.565,0,0,0-1.369-.274h-1.551V7.951h1.46A2.579,2.579,0,0,0,242.407,7.586Z",
    transform: "translate(-238.3 -4.3)",
    fill: "#585858"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDicomLabLogoDark);
export default __webpack_public_path__ + "static/media/dicomLAB_logo_dark.074baad0759e8c2a82409d68de30dff9.svg";
export { ForwardRef as ReactComponent };